import { render, staticRenderFns } from "./JoinCorporateCard.vue?vue&type=template&id=4c4e5e44&scoped=true&"
import script from "./JoinCorporateCard.vue?vue&type=script&lang=js&"
export * from "./JoinCorporateCard.vue?vue&type=script&lang=js&"
import style0 from "./JoinCorporateCard.vue?vue&type=style&index=0&id=4c4e5e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4e5e44",
  null
  
)

export default component.exports